import { css } from '@emotion/react';

import { colors } from '../../styles/colors';
import { ZeeFontBold, ZeeFontMedium } from '../../styles/font';
import { flex } from '../../styles/utils';

const delay = 0.22;

export const fadeIn = css`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  animation-duration: ${delay}s;
  animation-name: fadeIn;
`;
export const fadeOut = css`
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  animation-duration: ${delay}s;
  animation-name: fadeOut;
`;

export const slideIn = css`
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0%);
    }
  }
  animation-duration: ${delay}s;
  animation-name: slideIn;
`;

export const slideOut = css`
  @keyframes slideOut {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(100%);
    }
  }
  animation-duration: ${delay}s;
  animation-name: slideOut;
`;
const baseButton = css`
  border: 0px;
  border-radius: 6px;
  cursor: pointer;
  color: ${colors.PrimaryWhiteColor};
  padding: 12px 27px;
  ${flex()};
  ${ZeeFontMedium(14, 22)}
`;
export const outlineButton = css`
  ${baseButton};
  background: transparent;
  border: 1px solid ${colors.PrimaryWhiteColor};
`;
export const purpleButton = css`
  ${baseButton};
  background: ${colors.PurpleBtn};
`;

export const overlay = css`
  position: fixed;
  width: 100%;
  height: 100%;
  color: ${colors.PrimaryWhiteColor};
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: ${colors.PortalTransparentBg};
`;

export const MobileMenuHeader = css`
  ${flex()};
  padding: 8px;
  background-color: ${colors.AppBgColor};
`;

export const CloseButton = css`
  background: none;
  border: none;
  color: ${colors.PrimaryWhiteColor};
  &:after {
    background-color: ${colors.white};
    content: ' ';
    height: 25px;
    left: 25px;
    top: 15px;
    position: absolute;
    transform: rotate(45deg);
    width: 2px;
  }
  &:before {
    background-color: ${colors.white};
    content: ' ';
    height: 25px;
    top: 15px;
    left: 25px;
    position: absolute;
    transform: rotate(-45deg);
    width: 2px;
  }
`;

export const Zee5LogoContainer = css`
  ${flex()};
`;

export const Zee5Logo = css`
  width: 40px;
  height: 40px;
`;

export const purpleBackground = css`
  background-color: ${colors.MobileHamburgerBackgroundPurple};
`;

export const userNameContainer = css`
  padding: 16px 4px;
  ${ZeeFontBold(18)};
  color: ${colors.white};
`;

export const userProfile = css`
  width: 42px;
  height: 42px;
  &:before {
    font-size: 20px;
  }
  margin-right: 22px;
`;

export const buttonsContainer = css`
  ${flex()};
  gap: 27px;
  padding: 13px 10px;
  ${purpleBackground};
`;
